import { createSlice } from "@reduxjs/toolkit";
import VwPersonelDTO from "src/models/GenelTanimlar/VwPersonelDTO";
import { GridState } from "src/models/GridState";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";

 class IPersonelState extends GridState<VwPersonelDTO>{
  searchModel: VwPersonelDTO;
  searchDialogOpen: boolean;
}
const PersonelSlice = createSlice<IPersonelState, MapReducerPayloads<IPersonelState, {
  setState: IPersonelState,
  setLoading: boolean
}>>({
  name: 'personel',
  initialState: {
    searchModel: new VwPersonelDTO(),
    data: [],
    activeRow: new VwPersonelDTO(),
    searchDialogOpen: false
  },
  reducers: {
    setState: (state, action) => action.payload,
    setLoading: (state, action) => {
      state.isLoading = action.payload
    }
  }
})
export default PersonelSlice;